export const colorModeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: true,
}
